export class FeatureFlags {
    public static get isAdvancedSubscriptionsEnabled(): boolean {
        return (window as any)?.featureFlags?.isAdvancedSubscriptionsEnabled || false;
    }

    public static get isBeta(): boolean {
        return (window as any)?.featureFlags?.isBeta || false;
    }

    public static get isAdvanced(): boolean {
        return (window as any)?.featureFlags?.isAdvanced || false;
    }

    public static get crews(): boolean {
        return (window as any)?.featureFlags?.crews || false;
    }

    public static get crewActivity(): boolean {
        return (window as any)?.featureFlags?.crewActivity || false;
    }

    public static get geoTrackAnalyzer(): boolean {
        return (window as any)?.featureFlags?.geoTrackAnalyzer || false;
    }

    public static get graphRangeSelection(): boolean {
        return (window as any)?.featureFlags?.graphRangeSelection || false;
    }

    public static get graphVariableXAxis(): boolean {
        return (window as any)?.featureFlags?.graphVariableXAxis || false;
    }

    public static get rangeAnalyzer(): boolean {
        return (window as any)?.featureFlags?.rangeAnalyzer || false;
    }

    public static get snippets(): boolean {
        return (window as any)?.featureFlags?.snippets || false;
    }

    public static get strokeAnalyzer(): boolean {
        return (window as any)?.featureFlags?.strokeAnalyzer || false;
    }

    public static get extendedStrokeAnalyzer(): boolean {
        return (window as any)?.featureFlags?.extendedStrokeAnalyzer || false;
    }

    public static get graphSelection(): boolean {
        return (window as any)?.featureFlags?.graphSelection || false;
    }

    public static get outdoorIntervals(): boolean {
        return (window as any)?.featureFlags?.outdoorIntervals || false;
    }

    public static get outdoorGraphs(): boolean {
        return (window as any)?.featureFlags?.outdoorGraphs || false;
    }

    public static get powerSplit(): boolean {
        return (window as any)?.featureFlags?.powerSplit || false;
    }

    public static get reports(): boolean {
        return (window as any)?.featureFlags?.reports || false;
    }
}
